import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/octicons/octicons/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "https://www.npmjs.org/package/@primer/octicons"
      }}><img parentName="a" {...{
          "src": "https://img.shields.io/npm/v/@primer/octicons.svg",
          "alt": "npm version"
        }}></img></a></p>
    <h2>{`Install`}</h2>
    <p>{`This package is distributed with `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/"
      }}>{`npm`}</a>{`. After `}<a parentName="p" {...{
        "href": "https://docs.npmjs.com/getting-started/installing-node"
      }}>{`installing npm`}</a>{`, you can install `}<inlineCode parentName="p">{`@primer/octicons`}</inlineCode>{` with this command:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`npm install @primer/octicons
`}</code></pre>
    <h2>{`Usage`}</h2>
    <p>{`For all the usages, we recommend using the CSS located in `}<a parentName="p" {...{
        "href": "https://unpkg.com/@primer/octicons/build/build.css"
      }}><inlineCode parentName="a">{`build/build.css`}</inlineCode></a>{`. This is some simple CSS to normalize the icons and inherit colors.`}</p>
    <p>{`After installing `}<inlineCode parentName="p">{`@primer/octicons`}</inlineCode>{` you can access the icons like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`var octicons = require("@primer/octicons")
octicons.alert
// {
//     symbol: 'alert',
//     keywords: ['warning', 'triangle', 'exclamation', 'point'],
//     toSVG: [Function]
//     heights: {
//         16: {
//             width: 16,
//             path: '<path d="M8.865 1.52c-.18-.31-.51-.5-.87-.5s-.69.19-.87.5L.275 13.5c-.18.31-.18.69 0 1 .19.31.52.5.87.5h13.7c.36 0 .69-.19.86-.5.17-.31.18-.69.01-1L8.865 1.52zM8.995 13h-2v-2h2v2zm0-3h-2V6h2v4z"/>',
//             options: {
//                 version: '1.1',
//                 width: '16',
//                 height: '16',
//                 viewBox: '0 0 16 16',
//                 class: 'octicon octicon-alert',
//                 'aria-hidden': 'true'
//             },
//         },
//         24: ...
//     }
// }
`}</code></pre>
    <p>{`There will be a key for every icon, with `}<a parentName="p" {...{
        "href": "#octiconsnametosvg"
      }}><inlineCode parentName="a">{`toSVG`}</inlineCode></a>{` and other properties.`}</p>
    <p><em parentName="p">{`Note: `}<inlineCode parentName="em">{`alert`}</inlineCode>{` in the above example can be replaced with any valid icon name. Icons with multi-word names (e.g. `}<inlineCode parentName="em">{`arrow-right`}</inlineCode>{`) `}<strong parentName="em">{`cannot`}</strong>{` be accessed using dot notation (e.g. `}<inlineCode parentName="em">{`octicons.alert`}</inlineCode>{`). Instead, use bracket notation (e.g. `}<inlineCode parentName="em">{`octicons['arrow-right']`}</inlineCode>{`).`}</em></p>
    <h3><inlineCode parentName="h3">{`octicons[name].symbol`}</inlineCode></h3>
    <p>{`Returns the string of the symbol name, same as the key for that icon.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`octicons.x.symbol
// "x"
`}</code></pre>
    <h3><inlineCode parentName="h3">{`octicons[name].keywords`}</inlineCode></h3>
    <p>{`Returns an array of keywords for the icon. The data comes from `}<a parentName="p" {...{
        "href": "https://github.com/primer/octicons/blob/main/keywords.json"
      }}>{`keywords.json`}</a>{`. Consider contributing more aliases for the icons.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`octicons.x.keywords
// ["remove", "close", "delete"]
`}</code></pre>
    <h3><inlineCode parentName="h3">{`octicons[name].heights`}</inlineCode></h3>
    <p>{`Each icon can have multiple SVGs that are designed for different sizes. The `}<inlineCode parentName="p">{`heights`}</inlineCode>{` property allows you to access all the SVGs for an icon using the natural height of the SVG.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`octicons.x.heights
// {
//     16: {
//         width: 16,
//         path: '<path d="..."/>',
//         options: {
//             version: '1.1',
//             width: '16',
//             height: '16',
//             viewBox: '0 0 16 16',
//             class: 'octicon octicon-alert',
//             'aria-hidden': 'true'
//         },
//     },
//     24: {
//         width: 24,
//         path: '<path d="..."/>',
//         options: {
//             version: '1.1',
//             width: '24',
//             height: '24',
//             viewBox: '0 0 24 24',
//             class: 'octicon octicon-alert',
//             'aria-hidden': 'true'
//         },
//     },
// }
`}</code></pre>
    <h3><inlineCode parentName="h3">{`octicons[name].heights[height].width`}</inlineCode></h3>
    <p>{`Returns the icon's true width, based on the SVG view box width. `}<em parentName="p">{`Note, this doesn't change if you scale it up with size options, it only is the natural width of the icon.`}</em></p>
    <h3><inlineCode parentName="h3">{`octicons[name].heights[height].path`}</inlineCode></h3>
    <p>{`Returns the string representation of the path of the icon.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`octicons.x.heights[16].path
// <path d="M7.48 8l3.75 3.75-1.48 1.48L6 9.48l-3.75 3.75-1.48-1.48L4.52 8 .77 4.25l1.48-1.48L6 6.52l3.75-3.75 1.48 1.48z"></path>
`}</code></pre>
    <h3><inlineCode parentName="h3">{`octicons[name].heights[height].options`}</inlineCode></h3>
    <p>{`This is an object of all the attributes that will be added to the output tag.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`octicons.x.heights[16].options
// { version: '1.1', width: '12', height: '16', viewBox: '0 0 12 16', class: 'octicon octicon-x', 'aria-hidden': 'true' }
`}</code></pre>
    <h3><inlineCode parentName="h3">{`octicons[name].toSVG()`}</inlineCode></h3>
    <p>{`Returns a string of the `}<inlineCode parentName="p">{`<svg>`}</inlineCode>{` tag.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`octicons.x.toSVG()
// <svg version="1.1" width="12" height="16" viewBox="0 0 12 16" class="octicon octicon-x" aria-hidden="true"><path d="M7.48 8l3.75 3.75-1.48 1.48L6 9.48l-3.75 3.75-1.48-1.48L4.52 8 .77 4.25l1.48-1.48L6 6.52l3.75-3.75 1.48 1.48z"/></svg>
`}</code></pre>
    <p>{`The `}<inlineCode parentName="p">{`.toSVG()`}</inlineCode>{` method accepts an optional `}<inlineCode parentName="p">{`options`}</inlineCode>{` object. This is used to add CSS class names, accessibility options, and sizes.`}</p>
    <h4>{`class`}</h4>
    <p>{`Add more CSS classes to the `}<inlineCode parentName="p">{`<svg>`}</inlineCode>{` tag.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`octicons.x.toSVG({ "class": "close" })
// <svg version="1.1" width="12" height="16" viewBox="0 0 12 16" class="octicon octicon-x close" aria-hidden="true"><path d="M7.48 8l3.75 3.75-1.48 1.48L6 9.48l-3.75 3.75-1.48-1.48L4.52 8 .77 4.25l1.48-1.48L6 6.52l3.75-3.75 1.48 1.48z"/></svg>
`}</code></pre>
    <h4>{`aria-label`}</h4>
    <p>{`Add accessibility `}<inlineCode parentName="p">{`aria-label`}</inlineCode>{` to the icon.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`octicons.x.toSVG({ "aria-label": "Close the window" })
// <svg version="1.1" width="12" height="16" viewBox="0 0 12 16" class="octicon octicon-x" aria-label="Close the window" role="img"><path d="M7.48 8l3.75 3.75-1.48 1.48L6 9.48l-3.75 3.75-1.48-1.48L4.52 8 .77 4.25l1.48-1.48L6 6.52l3.75-3.75 1.48 1.48z"/></svg>
`}</code></pre>
    <h4>{`width and height`}</h4>
    <p>{`Size the SVG icon larger using `}<inlineCode parentName="p">{`width`}</inlineCode>{` and `}<inlineCode parentName="p">{`height`}</inlineCode>{` independently or together. `}<inlineCode parentName="p">{`.toSVG()`}</inlineCode>{` will automatically choose the best SVG to render based on the width or height passed in.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`octicons.x.toSVG({ "width": 45 })
// <svg version="1.1" width="45" height="45" viewBox="0 0 24 24" class="octicon octicon-x" aria-hidden="true"><path d="M7.48 8l3.75 3.75-1.48 1.48L6 9.48l-3.75 3.75-1.48-1.48L4.52 8 .77 4.25l1.48-1.48L6 6.52l3.75-3.75 1.48 1.48z"/></svg>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      